export default {"src":"/uk/_next/static/media/spot-plus-sign.665d6dad.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};